import $ from 'qwery';
import swipe from 'swipejs';
import { removeElement } from '../../helpers/domHelper';

function slider (slideContainer, opts = {}) {

    const defaults = {
        bottomButtons: false,
        callback: sliderChanged,
        continuous: false,
        masked: false,
        sideButtons: false,
        speed: 300
    };

    let options = {};
    let swipeInstance;
    let totalSlides;
    let nextBtn;
    let prevBtn;
    let bottomButtons;
    let mask;

    function setup () {

        if (!slideContainer) return;

        const swipeEl = $('.slider-wrapper', slideContainer)[0] || slideContainer;

        if (!swipeEl) return;

        options = Object.assign(defaults, opts);

        swipeInstance = swipe(swipeEl, options);

        totalSlides = swipeInstance.getNumSlides();

        if (options.sideButtons) {
            initSideButtons();
        }

        if (options.bottomButtons) {
            initBottomButtons();
        }

        if (options.masked) {
            initMask();
        }

        // Override default slide behaviour which prevents controls from recieving focus.
        const inputs = $('input', slideContainer);

        if (inputs && inputs.length > 0) {
            inputs.forEach(input => {
                input.addEventListener('click', event => {
                    event.target.focus();
                });
            });
        }
    }

    function removeSlider () {

        swipeInstance.kill();

        slideContainer.classList.add('is-hidden');

        if (mask) {
            removeElement(mask);
        }
    }

    function initSideButtons () {

        [prevBtn] = $('.slider-prev', slideContainer);

        if (prevBtn) {
            prevBtn.addEventListener('click', movePrev);
        }

        [nextBtn] = $('.slider-next', slideContainer);

        if (nextBtn) {
            nextBtn.addEventListener('click', moveNext);
            nextBtn.classList.remove('is-hidden');
        }
    }

    function initBottomButtons () {

        const buttons = document.createDocumentFragment();
        const slides = $('.slider-item', slideContainer);

        if (slides && slides.length > 0) {
            slides.forEach((slide, index) => {
                const button = document.createElement('div');

                button.setAttribute('data-slider-index', index);
                button.addEventListener('click', moveToSlide);
                button.classList.add('slider-control');

                if (index === 0) {
                    button.classList.add('is-active');
                }

                buttons.appendChild(button);
            });
        }

        [bottomButtons] = $('.slider-controls', slideContainer);

        if (bottomButtons) {
            bottomButtons.appendChild(buttons);
        }
    }

    function initMask () {

        const maskClass = 'sliderMask';
        const existingMask = $(`.${maskClass}`)[0];

        if (existingMask) return;

        mask = document.createElement('div');
        mask.classList.add(maskClass);
        mask.addEventListener('click', removeSlider);

        $('body')[0].appendChild(mask);
    }

    function moveToSlide (event) {

        const slideIndex = event.target.getAttribute('data-slider-index');

        swipeInstance.slide(slideIndex);
    }

    function moveNext () {

        const slide = swipeInstance.getPos() + 1;

        if (slide > totalSlides - 1) {
            return;
        }

        swipeInstance.slide(slide);
    }

    function sliderChanged (slideIndex) {

        swipeInstance.slide(slideIndex);

        if (options.sideButtons && nextBtn) {
            if (slideIndex === totalSlides - 1) {
                nextBtn.classList.add('is-hidden');
            } else {
                nextBtn.classList.remove('is-hidden');
            }
        }

        if (options.sideButtons && prevBtn) {
            if (slideIndex > 0) {
                prevBtn.classList.remove('is-hidden');
            } else {
                prevBtn.classList.add('is-hidden');
            }
        }

        if (options.bottomButtons && bottomButtons) {
            const wasActive = $('.is-active', bottomButtons)[0];

            if (wasActive) {
                wasActive.classList.remove('is-active');
            }

            const toBeActive = bottomButtons.children[slideIndex];

            if (toBeActive) {
                toBeActive.classList.add('is-active');
            }
        }
    }

    function movePrev () {

        const slide = swipeInstance.getPos() - 1;

        if (slide < 0) {
            return;
        }

        swipeInstance.slide(slide);
    }

    setup();

    return {
        swipeInstance,
        options
    };
}

function init () {

    const sliderElements = $('[data-slider]');

    if (sliderElements.length === 0) return null;

    return sliderElements.map(slideContainer => {

        const options = {
            masked: slideContainer.getAttribute('data-slider-masked') !== null,
            bottomButtons: slideContainer.getAttribute('data-slider-bottom-buttons') !== null,
            sideButtons: slideContainer.getAttribute('data-slider-side-buttons') !== null
        };

        return slider(slideContainer, options);
    });
}

export {
    slider,
    init
};
